// extracted by mini-css-extract-plugin
module.exports = {"astroWrapper":"Astro_astroWrapper__1g-ER","selectButton":"Astro_selectButton__dbdmY","errorText":"Astro_errorText__bGP6N"};